import propTypes from 'prop-types'
import classNames from 'classnames'

import Pagination from 'components/Pagination'
import Loader from 'components/Loader'


export default function List(props) {
  return (
    <div className={classNames(
      'my-5 relative',
      props.className,
    )}>
      <Loader
        active={!!props.loading}
        center
        containerClassName='bg-black bg-opacity-40'
      />
      {props.children}
      {
        props.pagination &&
        <Pagination
          {...props.pagination}
        />
      }
      {props.actions}
    </div>
  )
}


export function ListItem(props) {
  return (
    <div className={classNames(
      'border-b border-disabled-200 last:border-0',
      'flex items-center',
      props.className,
    )}>
      {props.children}
    </div>
  )
}


List.Item = ListItem


List.propTypes = {
  loading: propTypes.bool,
  pagination: propTypes.arrayOf(propTypes.shape({
    pages: propTypes.number.isRequired,
    selected: propTypes.number.isRequired,
    onChange: propTypes.func.isRequired,
  })),
  children: propTypes.oneOfType([
    propTypes.shape({
      type: propTypes.oneOf([ListItem]),
    }),
    propTypes.arrayOf(
      propTypes.shape({
        type: propTypes.oneOf([ListItem]),
      })
    ),
  ]).isRequired,
  className: propTypes.string,
}
